// T124 (16.10): „Mój zespół” — drzewko osób podlegających zalogowanemu (bezpośrednio i przez jego ludzi), z telefonem.
// Tylko podgląd; strukturę zmienia admin („Struktura firmy”).
import React, { useState, useEffect } from 'react';
import { RoleBadge, Avatar, fullName } from '../components/UI';
import { useAuth } from '../hooks/useAuth';
import api from '../utils/api';

export default function MyTeamPage() {
  const { user } = useAuth();
  const [rows, setRows] = useState(null);
  const [q, setQ] = useState('');
  const [error, setError] = useState('');
  useEffect(() => { api.getMyTeam().then(setRows).catch(e => setError(e.message)); }, []);

  if (error) return <p style={{ color: '#DC2626', padding: 20 }}>{error}</p>;
  if (!rows) return <p style={{ color: '#94A3B8', padding: 20 }}>Ładowanie…</p>;

  const kids = {};
  for (const r of rows) (kids[r.supervisorId] = kids[r.supervisorId] || []).push(r);
  const match = (r) => !q || `${fullName(r)} ${r.position || ''} ${r.phone || ''}`.toLowerCase().includes(q.toLowerCase());
  const anyMatch = (r) => match(r) || (kids[r.id] || []).some(anyMatch);
  const direct = (kids[user?.id] || []).length;

  const renderNode = (r) => {
    if (!anyMatch(r)) return null;
    const ch = kids[r.id] || [];
    return (
      <div key={r.id} style={{ marginLeft: r.depth > 1 ? 22 : 0, borderLeft: r.depth > 1 ? '2px solid #E2E8F0' : 'none', paddingLeft: r.depth > 1 ? 8 : 0 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '5px 6px', flexWrap: 'wrap', background: q && match(r) ? '#FEF9C3' : 'transparent', borderRadius: 6 }}>
          <Avatar name={fullName(r)} size={24} />
          <b style={{ fontSize: 12 }}>{fullName(r)}</b>
          <RoleBadge role={r.role} />
          {r.position && <span style={{ fontSize: 10, color: '#64748B' }}>{r.position}</span>}
          {ch.length > 0 && <span style={{ fontSize: 10, color: '#64748B' }}>· {ch.length} podwładn.</span>}
          <span style={{ marginLeft: 'auto', fontSize: 12 }}>
            {r.phone ? <a href={`tel:${r.phone.replace(/\s/g, '')}`} style={{ color: '#2563EB', textDecoration: 'none' }}>📞 {r.phone}</a> : <span style={{ color: '#CBD5E1' }}>brak telefonu</span>}
          </span>
        </div>
        {ch.map(renderNode)}
      </div>
    );
  };

  return (
    <div className="flex flex-col gap-14">
      <div className="page-header">
        <h2 className="page-title">Mój zespół</h2>
      </div>
      <div className="card">
        <div className="flex gap-8 flex-wrap" style={{ alignItems: 'center', marginBottom: 8 }}>
          <input placeholder="Szukaj osoby, stanowiska, telefonu…" value={q} onChange={e => setQ(e.target.value)} style={{ maxWidth: 260 }} />
          <span style={{ fontSize: 11, color: '#64748B', marginLeft: 'auto' }}>{direct} bezpośrednio · {rows.length} razem</span>
        </div>
        <div style={{ fontSize: 10, color: '#94A3B8', marginBottom: 10 }}>
          Osoby, którym jesteś przełożonym, i osoby podlegające Twoim ludziom. Zmiany w strukturze wprowadza admin.
        </div>
        {rows.length === 0 ? <p style={{ color: '#94A3B8' }}>Nikt Ci nie podlega.</p> : (kids[user?.id] || []).map(renderNode)}
      </div>
    </div>
  );
}
